import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ALL_ENT_VISTAS = 'ALL_ENT_VISTAS';
export const LOADING_ALL_ENT_VISTAS = 'LOADING_ALL_ENT_VISTAS';
export const ACTIVO_ENT_VISTAS = 'ACTIVO_ENT_VISTAS';
export const ALERT_VIEW_ENT_VISTAS = 'ALERT_VIEW_ENT_VISTAS';
export const ALERT_FORM_ENT_VISTAS = 'ALERT_FORM_ENT_VISTAS';
export const PARAMS_ENT_VISTAS = 'PARAMS_ENT_VISTAS';

const initialState = {
  all: [],
  loadingAll: false,
  activo: null,
  params: {},
};

export const entVistasReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_ENT_VISTAS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case LOADING_ALL_ENT_VISTAS:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case ACTIVO_ENT_VISTAS:
      return {
        ...state,
        activo: action.payload,
      };
    case PARAMS_ENT_VISTAS:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
